export const TRANSACTION_STATE = {
  CREATED: 0,
  DEPOSITED: 2,
  REVERSED: 3,
  REFUNDED: 4,
  WAITING_CONFIRMATION: 5,
  DECLINED: 6,
  IN_PROGRESS: 7,
  VOID: 8,
} as const
